import type { ReactNode } from 'react';

/** Shared by live-ticket and backtesting reports. */
export function RcaSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className='flex w-full flex-col gap-4'>
      <h2 className='text-base leading-6 font-semibold text-text-body'>{title}</h2>
      {children}
    </section>
  );
}

export function GapReportRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className='flex w-full items-stretch gap-3'>
      <span className='w-[120px] shrink-0 rounded-[8px] bg-muted px-3 py-1 text-body-sm leading-[18px] font-medium text-text-body'>
        {label}
      </span>
      <div className='min-w-0 flex-1 py-1 text-body-sm leading-[18px] text-gray-900'>{children}</div>
    </div>
  );
}
